module.exports = __webpack_public_path__ + "static/media/community-icon-github.efb390d2.svg";